import React, { Component } from "react";
import PropTypes from "prop-types";
import SidebarLink from "./SidebarLink";
import SidebarCategory from "./SidebarCategory";
import SidebarCategory1 from "./SidebarCategory1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWarehouse,
  faDolly,
  faBoxes,
  faFileAlt,
  faUpload,
  faFile,
  faTruck,
  faTachometerAlt,
  faWrench,
} from "@fortawesome/free-solid-svg-icons";

import dashboardIcon from '../../../images/dashboard.svg'
import './styles.css';
import {addAnalytics} from '../../Common/analytics';
//import setAnalytics from '../../Common/analytics';

class SidebarContent extends Component {
  static propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  state = {
    dashboard: false,
    master: false,
    master_view: false,
    storage: false,
    master_update: false,
    showPtlDataReport: false,
    viewMissingProduct: false,
    master_creation: false,
    master_mapping: false,
    inbound: false,
    outbond: false,
    create_putaway: false,
    showPtlApiReport: false,
    showMasterPtlDataReport: false,
    Bin_upload: false,
    showProduct: false,
    showReceiving: false,
    showPurchaseOrder: true,
    mis_weighted_avg_report: true,
    mis_dashboard: false,
    showOrders: false,
    showPacking: false,
    showPutaway: false,
    showDispatch: false,
    showPicking: false,

    showBin: false,
    showBrand: false,
    showCategory: false,
    showSubCategory: false,
    showSubDivision: false,
    showSKU7Code: false,
    showSKU7Ean: false,
    showSKU7ChildProduct: false,
    create_user: false,
    create_bulk_user : false,
    admin_reset_password : false,
    showSKU7Basepack: false,
    showSKU7CombinedProduct: false,
    cycle_count_approval: false,
    cycle_count_approval_new: false,
    showSKU7Packaging: false,
    showSKU7LBProduct: false,
    showBillDataDashboard: false,
    showBillDataDashboardNew: false,
    showStockMovementNew: false,
    showStockMovementApproval: false,
    mis_weighted_avg_report: false,
    showRetailerCode: false,
    showOutletCode: false,
    showAreaCode: false,
    showBeatAreaCode: false,
    show_beat_area_code_upload: false,
    showRetailerAreaMapping: false,
    showRetailerOCLDMapping: false,
    showRetailerProductOCLDMapping: false,
    showCompletedVansReport: false,
    showPtlbypass: true,
    createASN: false,
    sendToHHT: false,
    POSortClose: false,
    createInboundDelivery: false,
    // viewInboundDelivery: true,
    showWarehouseMaster: false,
    showCityMaster: false,
    showBrandMaster: false,
    showZoneMaster: false,
    showInventoryOwner: false,
    showTransactionstatus: false,
    mis_sto_report: false,
    retailerDCMapping: false,
    purchase_return_report: false,
    show_brand_upload: false,
    show_brand_view: false,
    show_zone_master: true,
    alternateProduct: false,
    alternateCreate: false,
    alternateView: false,
    show_category_view: false,
    show_category_upload: false,
    show_sub_category_upload: false,
    show_sub_category_view: false,
    show_sub_division_upload: false,
    show_sub_division_view: false,
    show_sku7_upload: false,
    show_sku7_view: false,
    show_sku7_ean_upload: false,
    show_sku7_ean_view: false,
    show_sku7_child_product_upload: false,
    show_beat_area_code_view: false,
    PurchaseReturn: false,
    BulkPurchaseReturn: false,
    show_cc_variance: false,
    show_cc_failure: false,
    show_invoice_failure: false,
    show_inbound_failure: false,
    show_inbound_srn_failure: false,
    mis_transaction_failure: false,
    show_transaction_failure: false,
    show_sku7_child_product_view: false,
    showoutboundReport: true,
    show_basepack_upload: false,
    show_basepack_view: false,
    show_combined_product_upload: false,
    show_combined_product_view: false,
    show_packaging_upload: false,
    show_packaging_view: false,
    show_lb_product_upload: false,
    showPickingTracking: false,
    showPickingPrioritization: false,
    show_lb_product_view: false,
    showDispatchConfirmReport: false,
    show_warehouse_master: true,
    show_brand_master: true,
    show_city_master: true,
    show_inventory_owner: true,
    secondary_bifurcation: false,
    billwise_to_case_picksheet_report: false,
    integration_report: false,
    show_retailer_code_upload: false,
    show_retailer_code_view: false,
    show_outlet_code_upload: false,
    show_outlet_code_view: false,
    show_area_code_upload: false,
    show_area_code_view: false,
    show_retailer_area_mapping_upload: false,
    show_retailer_area_mapping_view: false,
    show_retailer_ocld_mapping_upload: false,
    show_retailer_ocld_mapping_view: false,
    show_retailer_product_ocld_mapping_upload: false,
    show_retailer_product_ocld_mapping_view: false,
    inventory_analysis_report: false,
    cycle_count_report: false,
    stock_movement_report: false,
    sto_transaction: false,
    dues_report: false,

    showOrderUpload: false,
    showBillOrder: false,
    showUploadedOrdersBills: false,
    item_master: true,
    showExcess: false,
    showInboundReceiving: false,
    showPendingDataUpload: false,
    showMissingUpdate: false,
    showMismatch: false,
    showMissingProduct: false,
    showErrorInUpload: false,
    showGroupOrdersBill: false,
    showCreateGroup: false,
    showViewGroup: false,
    showAllocateInventory: false,
    showViewTask: false,
    showPickPackPlanning: false,
    showStockMovementMain: true,
    showSendToPackingStation: false,
    showUpdateEan: false,
    showPickingTracking: true,
    showPickingPrioritization: true,
    showPickingAssignTask: false,
    showPickingPrintTask: false,
    showPickingConfirmTask1: false,
    showBillEditingReport: false,
    showDRSIdReport: false,
    showDRSCLDReport: false,
    showBillVSPackingReport: false,
    showSODispatchReport: false,
    showInventoryAllocationReport: false,
    showCldDispatchReport: false,
    showBillOPCVanReport: false,
    showPickingCancelTask: false,
    showVanPlanning: false,
    showReadyToDispatch: false,
    showManualHandover: false,
    showTripPlanning: false,
    showPackingEdit: false,
    showBillReUpload: false,
    showPTLBYPASS: false,
    showBillEditConfig: false,
    showPtlToPackingConfig: false,
    mis_outbound: false,
    mis_cyclecount: false,
    show_cc_adjustment: false,
    mis_item_wise_transaction: false,
    showDispatchConfirmation: false,
    showDispatchReport: true,
    showTransactionReport: false,
    showoutbondReport: false,
    showInventoryReport: false,
    showStorageReport: false,
    showinboundReport: false,
    showPackingTaskReport: false,
    showSoToDispatch: false,
    showMasterPackingTaskReport: true,
    showPartyPackedReport: false,
    showPTLIncremental: false,
    showPTLComplate: false,
    showPackingStationZoneMaster: false,
    showPackingStationOrderMapping: false,
    allocate_putaway: false,
    showLooseCLDConfirmation: false,
    showBillwisePicksheet: false,
    showPurchseOrder: false,
    showPOToGRN: false,
    showPOShortReport: false,
    mis_report: false,
    showERPVsJarvis: false,
    mis_inventory_movement: false,
    mis_fill_rate_report: false,
    new_mis_fill_rate_report :false,
    mis_inbound: false,
    packed_vs_invoiced: false,

    showLynkMandiStock_report: false,

    showStorage: false,
    showStore: false,
    showWH_INIT: false,
    Bin_view: false,
    assign_putaway: false,
    print_putaway: false,
    confirm_putaway: false,
    PurchaseReturnApproval: false,
    POCreation: true,
    picking: false,
    create_picking: false,
    assign_picking: false,
    print_picking: false,
    confirm_picking: false,
    confirmed_tester_picking: false,
    dispatch: false,
    initiate_dispatch_picking: false,
    confirm_dispatch_picking: false,
    dispatch_report: false,
    cancel_picking: false,
    reports: false,
    inventory_report: false,
    uploadPrimaryUpload: false,
    dashboardPrimaryUpload: false,
    storage_report: false,
    transactional_report: false,
    maintenance: false,
    cycle_count: false,
    customer_vs_sap: false,
    showUpload: false,
    showBill: false,
    stock_movement: false,
    stock_movement_lakme: false,
    stock_transfer: false,
    bin_consolidation: false,
    delivery: false,
    delivery_upload: false,
    delivery_view: false,
    delivery_generatepicksheet: false,
    expandedItem: "",
    salesReturnGr: false,
    inventory_analysis_report: false,
    showHealthCheckReport: false,
    showInboundDeliveryReport: false,
    showReceivingReport: false,
    showSalesReturnReport: false,
    showPurchaseOrderReport: false,
    showAsnReport: false,
    showStiUpdate: true,
    stocktransferuploader : false,
    intransit_transaction: false,
    putaway_report:false,
    inbound_summary_report: false,
    mis_purchase_return: false,
    mis_dispatch_pending : false,
    pick_task_report:false,
    pending_order_vs_available_qty : true,
    packed_crate_report: false,
    mis_packed_crate_report: false,
    bin_to_bin_transfer : false,
    intransit_inventory_level:false,
    invoice_download : true,
    inbound_dashboard : false,
    stock_movement_to_good : false,
    expiry_report: false,
    show_shelf_life_upload:false,
    showShelfLife :false,
    staging_report:false

  };
 /* hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };*/

    hideSidebar = (menuName) => {
    // Function to handle sidebar link click and get the menu name
    console.log('Clicked on menu:', menuName);
    addAnalytics("SidebarLink", "changed sidebar link", menuName);
      //setAnalytics('no username', window.location.pathname);


     const { onClick } = this.props;
    onClick();
  }

  toggleLevel1 = (value) => {
    //const { collapse } = this.state;
    //this.setState({ expandedItemlevel1: value });
    console.log("sidebartoggleval", value);
     addAnalytics("SidebarCategory", "changed sidebar category", value);
    this.setState({ expandedItemlevel1: this.state.expandedItemlevel1 == value ? '' : value });
  };

  toggleLevel3 = (value) => {
    //const { collapse } = this.state;
    //this.setState({ expandedItemlefaTachometerAltvel3: value });
    addAnalytics("SidebarCategory", "changed sidebar category", value);
    this.setState({ expandedItemlevel3: this.state.expandedItemlevel3 == value ? '' : value });
  };

  toggleLevel2 = (value) => {
    //this.setState({ expandedItemlevel2: value });
    //const { collapse } = this.state;
    addAnalytics("SidebarCategory", "changed sidebar category", value);
    this.setState({ expandedItemlevel2: this.state.expandedItemlevel2 == value ? '' : value });
  };


  getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  componentDidMount() {
    console.log("SIDEBAR", window.location.pathname);
    var directPutawayFlag = this.getCookie("direct_putaway_flag");
    console.log('directPutawayFlag', directPutawayFlag)
    var NAV = this.getCookie("userMenu").split("-");
    console.log('NAV', NAV)
    var location = this.getCookie("selectedLocation")
    if (location.toLowerCase() == "vapi") {
      this.setState({
        showUpload: true,
        showBill: true
      })
    } else {
      this.setState({
        showUpload: true,
        showBill: true
      })
    }

    if (NAV.indexOf("1.0") > -1) {
      this.setState({
        dashboard: true,
      });
    }
    if (NAV.indexOf("1.1") > -1) {
      this.setState({
        inbound_dashboard: true,
      });
    }
    if (NAV.indexOf("2.0") > -1) {
      this.setState({
        master: true,
      });
    }
    if (NAV.indexOf("2.1") > -1) {
      this.setState({
        showStorage: true,
      });
    }
    if (NAV.indexOf("2.1.1") > -1) {
      this.setState({
        showBin: true,
      });
    }
    if (NAV.indexOf("2.1.1.1") > -1) {
      this.setState({
        Bin_upload: true,
      });
    }
    if (NAV.indexOf("2.1.1.2") > -1) {
      this.setState({
        Bin_view: true,
      });
    }
    if (NAV.indexOf("2.2") > -1) {
      this.setState({
        showProduct: true,
      });
    }
    if (NAV.indexOf("2.2.1") > -1) {
      this.setState({
        showBrand: true,
      });
    }
    if (NAV.indexOf("2.2.1.1") > -1) {
      this.setState({
        show_brand_upload: true,
      });
    }
    if (NAV.indexOf("2.2.1.2") > -1) {
      this.setState({
        show_brand_view: true,
      });
    }
    if (NAV.indexOf("2.2.2") > -1) {
      this.setState({
        showCategory: true,
      });
    }
    if (NAV.indexOf("2.2.2.1") > -1) {
      this.setState({
        show_category_upload: true,
      });
    }
    if (NAV.indexOf("2.2.2.2") > -1) {
      this.setState({
        show_category_view: true,
      });
    }
    if (NAV.indexOf("2.2.3") > -1) {
      this.setState({
        showSubCategory: true,
      });
    }
    if (NAV.indexOf("2.2.3.1") > -1) {
      this.setState({
        show_sub_category_upload: true,
      });
    }
    if (NAV.indexOf("2.2.3.2") > -1) {
      this.setState({
        show_sub_category_view: true,
      });
    }

    if (NAV.indexOf("2.2.4") > -1) {
      this.setState({
        showSubDivision: true,
      });
    }
    if (NAV.indexOf("2.2.4.1") > -1) {
      this.setState({
        show_sub_division_upload: true,
      });
    }
    if (NAV.indexOf("2.2.4.2") > -1) {
      this.setState({
        show_sub_division_view: true,
      });
    }

    if (NAV.indexOf("2.2.5") > -1) {
      this.setState({
        showSKU7Code: true,
      });
    }
    if (NAV.indexOf("2.2.5.1") > -1) {
      this.setState({
        show_sku7_upload: true,
      });
    }
    if (NAV.indexOf("2.2.5.2") > -1) {
      this.setState({
        show_sku7_view: true,
      });
    }

    if (NAV.indexOf("2.2.6") > -1) {
      this.setState({
        showSKU7Ean: true,
      });
    }
    if (NAV.indexOf("2.2.6.1") > -1) {
      this.setState({
        show_sku7_ean_upload: true,
      });
    }
    if (NAV.indexOf("2.2.6.2") > -1) {
      this.setState({
        show_sku7_ean_view: true,
      });
    }

    if (NAV.indexOf("2.2.7") > -1) {
      this.setState({
        showSKU7ChildProduct: true,
      });
    }
    if (NAV.indexOf("2.2.7.1") > -1) {
      this.setState({
        show_sku7_child_product_upload: true,
      });
    }
    if (NAV.indexOf("2.2.7.2") > -1) {
      this.setState({
        show_sku7_child_product_view: true,
      });
    }

    if (NAV.indexOf("2.2.8") > -1) {
      this.setState({
        showBasepack: true,
      });
    }
    if (NAV.indexOf("2.2.8.1") > -1) {
      this.setState({
        show_basepack_upload: true,
      });
    }
    if (NAV.indexOf("2.2.8.2") > -1) {
      this.setState({
        show_basepack_view: true,
      });
    }

    if (NAV.indexOf("2.2.9") > -1) {
      this.setState({
        showCombinedProduct: true,
      });
    }
    if (NAV.indexOf("2.2.9.1") > -1) {
      this.setState({
        show_combined_product_upload: true,
      });
    }
    if (NAV.indexOf("2.2.9.2") > -1) {
      this.setState({
        show_combined_product_view: true,
      });
    }

    if (NAV.indexOf("2.2.10") > -1) {
      this.setState({
        showPackaging: true,
      });
    }
    if (NAV.indexOf("2.2.10.1") > -1) {
      this.setState({
        show_packaging_upload: true,
      });
    }
    if (NAV.indexOf("2.2.10.2") > -1) {
      this.setState({
        show_packaging_view: true,
      });
    }



    if (NAV.indexOf("2.2.11") > -1) {
      this.setState({
        showLBProduct: true,
      });
    }
    if (NAV.indexOf("2.2.11.1") > -1) {
      this.setState({
        show_lb_product_upload: true,
      });
    }
    if (NAV.indexOf("2.2.11.2") > -1) {
      this.setState({
        show_lb_product_view: true,
      });
    }

    if (NAV.indexOf("2.2.12") > -1) {
      this.setState({
        alternateProduct: true,
      });
    }
    if (NAV.indexOf("2.2.12.1") > -1) {
      this.setState({
        alternateCreate: true,
      });
    }
    if (NAV.indexOf("2.2.12.2") > -1) {
      this.setState({
        alternateView: true,
      });
    }
    if (NAV.indexOf("2.2.13") > -1) {
      this.setState({
        showShelfLife: true,
      });
    }
    if (NAV.indexOf("2.2.13.1") > -1) {
      this.setState({
        show_shelf_life_upload: true,
      });
    }

    if (NAV.indexOf("2.3") > -1) {
      this.setState({
        showStore: true,
      });
    }

    if (NAV.indexOf("2.3.1") > -1) {
      this.setState({
        showRetailerCode: true,
      });
    }
    if (NAV.indexOf("2.3.1.1") > -1) {
      this.setState({
        show_retailer_code_upload: true,
      });
    }
    if (NAV.indexOf("2.3.1.2") > -1) {
      this.setState({
        show_retailer_code_view: true,
      });
    }

    if (NAV.indexOf("2.3.2") > -1) {
      this.setState({
        showOutletCode: true,
      });
    }
    if (NAV.indexOf("2.3.2.1") > -1) {
      this.setState({
        show_outlet_code_upload: true,
      });
    }
    if (NAV.indexOf("2.3.2.2") > -1) {
      this.setState({
        show_outlet_code_view: true,
      });
    }

    if (NAV.indexOf("2.3.3") > -1) {
      this.setState({
        showAreaCode: true,
      });
    }
    if (NAV.indexOf("2.3.3.1") > -1) {
      this.setState({
        show_area_code_upload: true,
      });
    }
    if (NAV.indexOf("2.3.3.2") > -1) {
      this.setState({
        show_area_code_view: true,
      });
    }

    if (NAV.indexOf("2.3.4") > -1) {
      this.setState({
        showRetailerAreaMapping: true,
      });
    }
    if (NAV.indexOf("2.3.4.1") > -1) {
      this.setState({
        show_retailer_area_mapping_upload: true,
      });
    }
    if (NAV.indexOf("2.3.4.2") > -1) {
      this.setState({
        show_retailer_area_mapping_view: true,
      });
    }

    if (NAV.indexOf("2.3.5") > -1) {
      this.setState({
        showRetailerOCLDMapping: true,
      });
    }
    if (NAV.indexOf("2.3.5.1") > -1) {
      this.setState({
        show_retailer_ocld_mapping_upload: true,
      });
    }
    if (NAV.indexOf("2.3.5.2") > -1) {
      this.setState({
        show_retailer_ocld_mapping_view: true,
      });
    }

    if (NAV.indexOf("2.3.6") > -1) {
      this.setState({
        showRetailerProductOCLDMapping: true,
      });
    }
    if (NAV.indexOf("2.3.6.1") > -1) {
      this.setState({
        show_retailer_product_ocld_mapping_upload: true,
      });
    }
    if (NAV.indexOf("2.3.6.2") > -1) {
      this.setState({
        show_retailer_product_ocld_mapping_view: true,
      });
    }
     if (NAV.indexOf("2.3.7") > -1) {
      this.setState({
        showBeatAreaCode: true,
      });
    }
     if (NAV.indexOf("2.3.7.1") > -1) {
      this.setState({
        show_beat_area_code_upload: true,
      });
    }
     if (NAV.indexOf("2.3.7.2") > -1) {
      this.setState({
        show_beat_area_code_view: true,
      });
    }
    if (NAV.indexOf("2.4") > -1) {
      this.setState({
        showWH_INIT: true,
      });
    }
    if (NAV.indexOf("2.4.1") > -1) {
      this.setState({
        showWarehouseMaster: true,
      });
    }
    if (NAV.indexOf("2.4.2") > -1) {
      this.setState({
        showCityMaster: true,
      });
    }
    if (NAV.indexOf("2.4.3") > -1) {
      this.setState({
        showBrandMaster: true,
      });
    }
    if (NAV.indexOf("2.4.4") > -1) {
      this.setState({
        showInventoryOwner: true,
      });
    }

    if (NAV.indexOf("2.4.5") > -1) {
      this.setState({
        showZoneMaster: true,
      });
    }

    if (NAV.indexOf("3.0") > -1) {
      this.setState({
        inbound: true,
      });
    }
    if (NAV.indexOf("3.1") > -1) {
      this.setState({
        showReceiving: true,
      });
    }
    if (NAV.indexOf("3.3") > -1) {
      this.setState({
        showPurchaseOrder: true,
      });
    }

    if (NAV.indexOf("3.1.1") > -1) {
      this.setState({
        uploadPrimaryUpload: true,
      });
    }

     if(directPutawayFlag == "false"){
      this.setState({
        dashboardPrimaryUpload: false,
      });
    }
    else if (NAV.indexOf("3.1.2") > -1) {
      this.setState({
        dashboardPrimaryUpload: true,
      });
    }else{
      this.setState({
        dashboardPrimaryUpload: true,
      });
    }
    if (NAV.indexOf("3.1.3") > -1) {
      this.setState({
        createInboundDelivery: true,
      });
    }

   if (NAV.indexOf("3.1.4") > -1) {
      this.setState({
        createASN: true,
      });
    }

    if (NAV.indexOf("3.1.5") > -1) {
      this.setState({
        showInboundReceiving: true,
      });
    }

    if (NAV.indexOf("3.1.6") > -1) {
      this.setState({
        showMissingProduct: true,
      });
    }

    if (NAV.indexOf("3.1.7") > -1) {
      this.setState({
        showMissingUpdate: true,
      });
    }

    if (NAV.indexOf("3.1.8") > -1) {
      this.setState({
        showMismatch: true,
      });
    }
    if (NAV.indexOf("3.1.9") > -1) {
      this.setState({
        showExcess: true,
      });
    }
    if (NAV.indexOf("3.1.10") > -1) {
      this.setState({
        POSortClose: true,
      });
    }
    if (NAV.indexOf("3.1.11") > -1) {
      this.setState({
        PurchaseReturn: true,
      });
    }
    if (NAV.indexOf("3.1.12") > -1) {
      this.setState({
        PurchaseReturnApproval: true,
      });
    }
    if (NAV.indexOf("3.1.13") > -1) {
      this.setState({
        retailerDCMapping: true,
      });
    }

 /*   if(directPutawayFlag == "false"){
      this.setState({
        showPendingDataUpload: true,
      });
    }else*/
     if (NAV.indexOf("3.1.14") > -1) {
      this.setState({
        showPendingDataUpload: true,
      });
    }/*else{
      this.setState({
        showPendingDataUpload: false,
      });
    }*/

      if(directPutawayFlag == true){
        this.setState({
          sendToHHT: false,
        });
      } else if (NAV.indexOf("3.1.15") > -1) {
        this.setState({
          sendToHHT: true,
        });
      }
      if (NAV.indexOf("3.1.16") > -1) {
        this.setState({
          BulkPurchaseReturn: true,
        });
      }


    if (NAV.indexOf("3.2") > -1) {
      this.setState({
        showPutaway: true,
      });
    }

    if (NAV.indexOf("3.2.1") > -1) {
      this.setState({
        create_putaway: true,
      });
    }


  
    if (NAV.indexOf("3.2.2") > -1) {
      console.log("DIRECTPUTAWAY2")

     this.setState({
        assign_putaway: true,
      });
    }


    if (NAV.indexOf("3.2.2.1") > -1) {
     

     this.setState({
        allocate_putaway: true,
      });
    }
  

  

    if (NAV.indexOf("3.2.3") > -1) {
      this.setState({
        print_putaway: true,
      });
    }

    if (NAV.indexOf("3.2.4") > -1) {
      this.setState({
        confirm_putaway: true,
      });
    }


    if (NAV.indexOf("4.0") > -1) {
      this.setState({
        outbond: true,
      });
    }

    if (NAV.indexOf("4.1") > -1) {
      this.setState({
        showOrders: true,
      });
    }

    if (NAV.indexOf("4.1.1") > -1) {
      this.setState({
        showOrderUpload: true,
      });
    }

    if (NAV.indexOf("4.1.2") > -1) {
      this.setState({
        showBillUpload: true,
      });
    }

    if (NAV.indexOf("4.1.3") > -1) {
      this.setState({
        showUploadedOrdersBills: true,
      });
    }

    if (NAV.indexOf("4.1.4") > -1) {
      this.setState({
        showErrorInUpload: true,
      });
    }

    if (NAV.indexOf("4.1.5") > -1) {
      this.setState({
        showGroupOrdersBill: true,
      });
    }

    if (NAV.indexOf("4.1.6") > -1) {
      this.setState({
        showBillDataDashboard: true,
      });
    }

    if (NAV.indexOf("4.1.7") > -1) {
      this.setState({
        showBillDataDashboardNew: true,
      });
    }


    if (NAV.indexOf("4.1.5.1") > -1) {
      this.setState({
        showCreateGroup: true,
      });
    }

    if (NAV.indexOf("4.1.5.2") > -1) {
      this.setState({
        showViewGroup: true,
      });
    }

    if (NAV.indexOf("4.1.5.3") > -1) {
      this.setState({
        showAllocateInventory: true,
      });
    }


    if (NAV.indexOf("4.2") > -1) {
      this.setState({
        showPicking: true,
      });
    }

    if (NAV.indexOf("4.2.1") > -1) {
      this.setState({
        showViewTask: true,
      });
    }

    if (NAV.indexOf("4.2.2") > -1) {
      this.setState({
        showPickPackPlanning: true,
      });
    }

    if (NAV.indexOf("4.2.3") > -1) {
      this.setState({
        showSendToPackingStation: true,
      });
    }

    if (NAV.indexOf("4.2.4") > -1) {
      this.setState({
        showPickingAssignTask: true,
      });
    }

    if (NAV.indexOf("4.2.5") > -1) {
      this.setState({
        showPickingPrintTask: true,
      });
    }

    if (NAV.indexOf("4.2.6") > -1) {
      this.setState({
        showPickingConfirmTask1: true,
      });
    }

    if (NAV.indexOf("4.2.8") > -1) {
      this.setState({
        showLooseCLDConfirmation: true,
      });
    }

    if (NAV.indexOf("4.2.9") > -1) {
      this.setState({
        showBillwisePicksheet: true,
      });
    }

    if (NAV.indexOf("4.2.7") > -1) {
      this.setState({
        showPickingCancelTask: true,
      });
    }

    if (NAV.indexOf("4.2.10") > -1) {
      this.setState({
        showUpdateEan: true,
      });
    }

     if (NAV.indexOf("4.2.11") > -1) {
      this.setState({
        showPickingTracking: true,
      });
    }

    
     if (NAV.indexOf("4.2.12") > -1) {
      this.setState({
        showPickingPrioritization: true,
      });
    }

    if (NAV.indexOf("4.3") > -1) {
      this.setState({
        showPacking: true,
      });
    }


    if (NAV.indexOf("4.3.1") > -1) {
      this.setState({
        showPackingEdit: true,
      });
    }

    if (NAV.indexOf("4.3.3") > -1) {
      this.setState({
        showBillReUpload: true,
      });
    }

    if (NAV.indexOf("4.3.4") > -1) {
      this.setState({
        showPTLBYPASS: true,
      });
    }

    if (NAV.indexOf("4.3.5") > -1) {
      this.setState({
        showDispatchConfirm: true,
      });
    }

    if (NAV.indexOf("4.3.6") > -1) {
      this.setState({
        showBillEditConfig: true,
      });
    }

    if (NAV.indexOf("4.3.7") > -1) {
      this.setState({
        showPtlToPackingConfig: true,
      });
    }




    if (NAV.indexOf("4.4") > -1) {
      this.setState({
        showDispatch: true,
      });
    }


    if (NAV.indexOf("4.4.1") > -1) {
      this.setState({
        showVanPlanning: true,
      });
    }

    if (NAV.indexOf("4.4.2") > -1) {
      this.setState({
        showReadyToDispatch: true,
      });
    }

    if (NAV.indexOf("4.4.3") > -1) {
      this.setState({
        showDispatchConfirmation: true,
      });
    }

    if (NAV.indexOf("4.4.4") > -1) {
      this.setState({
        showManualHandover: true,
      });
    }
    if (NAV.indexOf("4.4.5") > -1) {
      this.setState({
        showTripPlanning: true,
      });
    }


    if (NAV.indexOf("7.1") > -1) {
      this.setState({
        showinboundReport: true,
      });
    }
    if (NAV.indexOf("7.1.1") > -1) {
      this.setState({
        showPurchseOrder: true,
      });
    }
    if (NAV.indexOf("7.1.2") > -1) {
      this.setState({
        showPOToGRN: true,
      });
    }

    if (NAV.indexOf("7.1.3") > -1) {
      this.setState({
        showHealthCheckReport: true,
      });
    }
    if (NAV.indexOf("7.1.4") > -1) {
      this.setState({
        showInboundDeliveryReport: true,
      });
    }
    if (NAV.indexOf("7.1.5") > -1) {
      this.setState({
        showAsnReport: true,
      });
    }
    if (NAV.indexOf("7.1.6") > -1) {
      this.setState({
        showReceivingReport: true,
      });
    }
    if (NAV.indexOf("7.1.7") > -1) {
      this.setState({
        showSalesReturnReport: true,
      });
    }
    if (NAV.indexOf("7.1.8") > -1) {
      this.setState({
        salesReturnGr: true,
      });
    }

    if (NAV.indexOf("7.1.9") > -1) {
      this.setState({
        showPOShortReport: true,
      });
    }

    if (NAV.indexOf("7.1.10") > -1) {
      this.setState({
        purchase_return_report: true,
      });
    }
    if (NAV.indexOf("7.1.11") > -1) {
      this.setState({
        putaway_report: true,
      });
    }
    if (NAV.indexOf("7.1.12") > -1) {
      this.setState({
        inbound_summary_report: true,
      });
    }
    if (NAV.indexOf("7.1.13") > -1) {
      this.setState({
        staging_report: true,
      });
    }





    if (NAV.indexOf("7.2") > -1) {
      this.setState({
        showOutbondReport: true,
      });
    }

    if (NAV.indexOf("7.2.1") > -1) {
      this.setState({
        showPackingTaskReport: true,
      });
    }

    if (NAV.indexOf("7.2.2") > -1) {
      this.setState({
        showPTLIncremental: true,
      });
    }

    if (NAV.indexOf("7.2.3") > -1) {
      this.setState({
        showPTLComplate: true,
      });
    }

    if (NAV.indexOf("7.2.4") > -1) {
      this.setState({
        showPackingStationZoneMaster: true,
      });
    }

    if (NAV.indexOf("7.2.5") > -1) {
      this.setState({
        showPackingStationOrderMapping: true,
      });
    }

    if (NAV.indexOf("7.2.6") > -1) {
      this.setState({
        showPartyPackedReport: true,
      });
    }

    if (NAV.indexOf("7.2.7") > -1) {
      this.setState({
        showPtlApiReport: true,
      });
    }

    if (NAV.indexOf("7.2.8") > -1) {
      this.setState({
        showMasterPtlDataReport: true,
      });
    }

    if (NAV.indexOf("7.2.9") > -1) {
      this.setState({
        showPtlDataReport: true,
      });
    }

    if (NAV.indexOf("7.2.10") > -1) {
      this.setState({
        showDispatchConfirmReport: true,
      });
    }

    if (NAV.indexOf("7.2.11") > -1) {
      this.setState({
        showCompletedVansReport: true,
      });
    }

    if (NAV.indexOf("7.2.12") > -1) {
      this.setState({
        showBillEditingReport: true,
      });
    }

    if (NAV.indexOf("7.2.13") > -1) {
      this.setState({
        showBillOPCVanReport: true,
      });
    }

    if (NAV.indexOf("7.2.14") > -1) {
      this.setState({
        showDRSIdReport: true,
      });
    }

    if (NAV.indexOf("7.2.15") > -1) {
      this.setState({
        showSODispatchReport: true,
      });
    }
    if (NAV.indexOf("7.2.16") > -1) {
      this.setState({
        showInventoryAllocationReport: true,
      });
    }
    if (NAV.indexOf("7.2.17") > -1) {
      this.setState({
        showCldDispatchReport: true,
      });
    }

    if (NAV.indexOf("7.2.18") > -1) {
      this.setState({
        showSoToDispatch: true,
      })
    }
    if (NAV.indexOf("7.2.19") > -1) {
      this.setState({
        secondary_bifurcation: true,
      });
    }
    if (NAV.indexOf("7.2.20") > -1) {
      this.setState({
        billwise_to_case_picksheet_report: true,
      });
    }
    if (NAV.indexOf("7.2.21") > -1) {
      this.setState({
        integration_report: true,
      });
    }
    if (NAV.indexOf("7.2.22") > -1) {
      this.setState({
        sto_transaction: true,
      });
    }

    if (NAV.indexOf("7.2.23") > -1) {
      this.setState({
        dues_report: true,
      });
    }

    if (NAV.indexOf("7.2.24") > -1) {
      this.setState({
        showDRSCLDReport: true,
      });
    }

    if (NAV.indexOf("7.2.25") > -1) {
      this.setState({
        showBillVSPackingReport: true,
      });
    }
    if (NAV.indexOf("7.2.26") > -1) {
      this.setState({
        pick_task_report: true,
      });
    }
    if (NAV.indexOf("7.2.26") > -1) {
      this.setState({
        pending_order_vs_available_qty : true,
      });
    }

      if (NAV.indexOf("7.2.28") > -1) {
      this.setState({
        packed_crate_report : true,
      });
    }




    if (NAV.indexOf("7.3") > -1) {
      this.setState({
        showInventoryReport: true,
      });
    }


    if (NAV.indexOf("7.4") > -1) {
      this.setState({
        showStorageReport: true,
      });
    }

    if (NAV.indexOf("7.5") > -1) {
      this.setState({
        showTransactionReport: true,
      });
    }
    if (NAV.indexOf("7.5.2") > -1) {
      this.setState({
        expiry_report: true,
      });
    }


    if (NAV.indexOf("7.6") > -1) {
      this.setState({
        showTransactionstatus: true,
      });
    }
    if (NAV.indexOf("7.7") > -1) {
      this.setState({
        invoice_download: true,
      });
    }



    if (NAV.indexOf("9.0") > -1) {
      this.setState({
        mis_dashboard: true,
      });
    }

    if (NAV.indexOf("9.1") > -1) {
      this.setState({
        mis_report: true,
      });
    }
    if (NAV.indexOf("9.1.1") > -1) {
      this.setState({
        showERPVsJarvis: true,
      });
    }
    if (NAV.indexOf("9.1.1.3") > -1) {
      this.setState({
        intransit_inventory_level: true,
      });
    }

    if (NAV.indexOf("9.1.2") > -1) {
      this.setState({
        mis_inventory_movement: true,
      });
    }
    if (NAV.indexOf("9.1.3") > -1) {
      this.setState({
        mis_fill_rate_report: true,
      });
    }
    if (NAV.indexOf("9.1.4") > -1) {
      this.setState({
        packed_vs_invoiced: true,
      });
    }

    if (NAV.indexOf("9.1.5") > -1) {
      this.setState({
        mis_inbound: true,
      });
    }

    if (NAV.indexOf("9.1.6") > -1) {
      this.setState({
        mis_outbound: true,
      });
    }

    if (NAV.indexOf("9.1.7") > -1) {
      this.setState({
        mis_cyclecount: true,
      });
    }



    if (NAV.indexOf("9.1.9") > -1) {
      this.setState({
        show_cc_variance: true,
      });
    }
    if (NAV.indexOf("9.1.11") > -1) {
      this.setState({
        show_cc_failure: true,
      });
    }
    if (NAV.indexOf("9.1.12") > -1) {
      this.setState({
        show_invoice_failure: true,
      });
    }
    if (NAV.indexOf("9.1.13") > -1) {
      this.setState({
        show_inbound_failure: true,
      });
    }
    if (NAV.indexOf("9.1.15") > -1) {
      this.setState({
        show_inbound_srn_failure: true,
      });
    }
    if (NAV.indexOf("9.1.16") > -1) {
      this.setState({
        mis_transaction_failure: true,
      });
    }
    if (NAV.indexOf("9.1.14") > -1) {
      this.setState({
        show_transaction_failure: true,
      });
    }

    if (NAV.indexOf("9.1.8") > -1) {
      this.setState({
        mis_item_wise_transaction: true,
      });
    }
    if (NAV.indexOf("9.1.17") > -1) {
      this.setState({
        mis_sto_report: true,
      });
    }
    if (NAV.indexOf("9.1.18") > -1) {
      this.setState({
        bin_consolidation: true,
      });
    }
    if (NAV.indexOf("9.1.20") > -1) {
      this.setState({
        intransit_transaction: true,
      });
    }

    if (NAV.indexOf("9.1.10") > -1) {
      this.setState({
        show_cc_adjustment: true,
      });
    }
    if (NAV.indexOf("9.1.21") > -1) {
      this.setState({
        bin_to_bin_transfer: true,
      });
    }
    if (NAV.indexOf("9.1.22") > -1) {
      this.setState({
        mis_dispatch_pending: true,
      });
    }
    if (NAV.indexOf("9.1.23") > -1) {
      this.setState({
        mis_purchase_return: true,
      });
    }
    if (NAV.indexOf("9.1.24") > -1) {
      this.setState({
        new_mis_fill_rate_report : true,
      });
    }
    if (NAV.indexOf("9.1.25") > -1) {
      this.setState({
        mis_packed_crate_report : true,
      });
    }

      if (NAV.indexOf("9.1.26") > -1) {
      this.setState({
        mis_weighted_avg_report : true,
      });
    }

    if (NAV.indexOf("10.1") > -1) {
      this.setState({
        create_user : true,
      });
    }
    if (NAV.indexOf("10.2") > -1) {
      this.setState({
        create_bulk_user : true,
      });
    }
    if (NAV.indexOf("10.3") > -1) {
      this.setState({
        admin_reset_password : true,
      });
    }


    if (NAV.indexOf("2.1") > -1) {
      this.setState({
        master_view: true,
      });
    }
    if (NAV.indexOf("2.2") > -1) {
      this.setState({
        master_update: true,
      });
    }
    if (NAV.indexOf("2.3") > -1) {
      this.setState({
        master_creation: true,
      });
    }


    if (NAV.indexOf("4.0") > -1) {
      this.setState({
        delivery: true,
      });
    }
    if (NAV.indexOf("4.1") > -1) {
      this.setState({
        delivery_upload: true,
      });
    }
    if (NAV.indexOf("4.2") > -1) {
      this.setState({
        delivery_view: true,
      });
    }
    if (NAV.indexOf("4.3") > -1) {
      this.setState({
        delivery_generatepicksheet: true,
      });
    }

    if (NAV.indexOf("5.0") > -1) {
      this.setState({
        picking: true,
      });
    }
    if (NAV.indexOf("5.1") > -1) {
      this.setState({
        create_picking: true,
      });
    }
    if (NAV.indexOf("5.2") > -1) {
      this.setState({
        assign_picking: true,
      });
    }
    if (NAV.indexOf("5.3") > -1) {
      this.setState({
        print_picking: true,
      });
    }
    if (NAV.indexOf("5.4") > -1) {
      this.setState({
        confirm_picking: true,
      });
    }
    if (NAV.indexOf("5.5") > -1) {
      this.setState({
        confirmed_tester_picking: true,
      });
    }
    if (NAV.indexOf("5.6") > -1) {
      this.setState({
        confirm_dispatch_picking: true,
      });
    }
    if (NAV.indexOf("5.7") > -1) {
      this.setState({
        cancel_picking: true,
      });
    }
    if (NAV.indexOf("7.0") > -1) {
      this.setState({
        reports: true,
      });
    }
    if (NAV.indexOf("7.3.1") > -1) {
      this.setState({
        inventory_report: true,
      });
    }
    if (NAV.indexOf("7.3.2") > -1) {
      this.setState({
        showLynkMandiStock_report: true,
      });
    }
    if (NAV.indexOf("7.3.3") > -1) {
      this.setState({
        inventory_analysis_report: true,
      });
    }
    if (NAV.indexOf("7.3.4") > -1) {
      this.setState({
        cycle_count_report: true,
      });
    }
    if (NAV.indexOf("7.3.5") > -1) {
      this.setState({
        stock_movement_report: true,
      });
    }
    if (NAV.indexOf("7.4.1") > -1) {
      this.setState({
        storage_report: true,
      });
    }
    if (NAV.indexOf("7.5.1") > -1) {
      this.setState({
        transactional_report: true,
      });
    }
    if (NAV.indexOf("6.0") > -1) {
      this.setState({
        maintenance: true,
      });
    }
    if (NAV.indexOf("6.1") > -1) {
      this.setState({
        cycle_count: true,
      });
    }
    if (NAV.indexOf("6.2") > -1) {
      this.setState({
        customer_vs_sap: true,
      });
    }
    if (NAV.indexOf("6.3") > -1) {
      this.setState({
        stock_movement: true,
      });
    }


    if (NAV.indexOf("6.4") > -1) {
      this.setState({
        cycle_count_approval: true,
      });
    }
    if (NAV.indexOf("6.10") > -1) {
      this.setState({
        cycle_count_approval_new: true,
      });
    }
    if (NAV.indexOf("6.5") > -1) {
      this.setState({
        stock_transfer: true,
      });
    }
    if (NAV.indexOf("6.5.4") > -1) {
      this.setState({
        stock_movement_to_good: true,
      });
    }

    if (NAV.indexOf("6.6") > -1) {
      this.setState({
        stock_movement_lakme: true,
      });
    }

    if (NAV.indexOf("6.7") > -1) {
      this.setState({
        showStockMovementApproval: true,
      });
    }
    if (NAV.indexOf("6.8") > -1) {
      this.setState({
        showStockMovementMain: true,
      });
    }
    if (NAV.indexOf("6.9") > -1) {
      this.setState({
        showStiUpdate: true,
      });
    }
    if (NAV.indexOf("6.10") > -1) {
      this.setState({
       stocktransferuploader : true,
      });
    }
    if (NAV.indexOf("7.4") > -1) {
      this.setState({
        bin_consolidation: true,
      });
    }
    if (NAV.indexOf("8.0") > -1) {
      this.setState({
        delivery: true,
      });
    }
    if (NAV.indexOf("8.1") > -1) {
      this.setState({
        delivery_upload: true,
      });
    }
    if (NAV.indexOf("8.2") > -1) {
      this.setState({
        delivery_view: true,
      });
    }
    if (NAV.indexOf("8.3") > -1) {
      this.setState({
        delivery_generatepicksheet: true,
      });
    }
    if (NAV.indexOf("8.4") > -1) {
      this.setState({
        dispatch: true,
      });
    }
    if (NAV.indexOf("8.5") > -1) {
      this.setState({
        initiate_dispatch_picking: true,
      });
    }
    if (NAV.indexOf("8.6") > -1) {
      this.setState({
        dispatch_report: true,
      });
    }
  }

  render() {
    const { changeToLight, changeToDark, changeSidebarVisibility } = this.props;

    return (
      <div className="sidebar__content">
        {this.state.dashboard && (
          <ul
            className="sidebar__block"
            style={{ borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8 }}
          >
            
            <SidebarCategory
              title="1. Dashboard"
              icon={faTachometerAlt}
              collapse={this.state.expandedItemlevel2 == "1. Dashboard"}
              ontoggle={(title) => this.toggleLevel2(title)}
              // changeSidebarVisibility={changeSidebarVisibility}
              route="/dashboard_default"
              onClick={this.hideSidebar}
            >
              {this.state.inbound_dashboard && (
              <SidebarLink
              title="1.1 Inbound Dashboard"
              route="/inbound_dashboard"
              onClick={this.hideSidebar}
              />
              )}
              </SidebarCategory>
            
          </ul>
        )}

        {this.state.mis_dashboard && (
          <ul
            className="sidebar__block"
            style={{ borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8 }}
          >

            <SidebarLink
              title="1. MIS Dashboard"
              icon={faTachometerAlt}
              changeSidebarVisibility={changeSidebarVisibility}
              route="/dashboard_mis"
              onClick={this.hideSidebar}
            />
          </ul>
        )}

        {this.state.master && (
          <ul
            className="sidebar__block"
            style={{ borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8 }}
          >
            <SidebarCategory
              title="2. Masters"
              icon={faUpload}
              changeSidebarVisibility={changeSidebarVisibility}
              collapse={this.state.expandedItemlevel1 == "2. Masters"}
              /*ontoggle={this.toggleLevel1}*/
              ontoggle={(title) => this.toggleLevel1(title)}
            >
              {this.state.showStorage &&
                <SidebarCategory
                  title="2.1 Storage"
                  collapse={this.state.expandedItemlevel2 == "2.1 Storage"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}
                  changeSidebarVisibility={changeSidebarVisibility}
                >
                  {this.state.showBin &&
                    <SidebarCategory
                      title="Parent Code Zone Mapping"
                      collapse={this.state.expandedItemlevel3 == "Parent Code Zone Mapping"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}

                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.master_update && (
                        <SidebarLink
                          title="Upload"
                          route="/upload/master_form_update"
                          onClick={this.hideSidebar}
                        />
                      )}
                      {this.state.master_view && (
                        <SidebarLink
                          title="View"
                          route="/upload/master_form"
                          onClick={this.hideSidebar}
                        />
                      )}

                    </SidebarCategory>
                  }





                  {/*<SidebarLink
                  title="Category Master Upload"
                  route="/upload/category_form_update"
                  onClick={this.hideSidebar}
                />*/}






                  {/*<SidebarLink
                  title="View"
                  route="/upload/view_category_master_form"
                  onClick={this.hideSidebar}
                />*/}





                </SidebarCategory>
              }

              {this.state.showProduct &&
                <SidebarCategory
                  title="2.2 Product"
                  collapse={this.state.expandedItemlevel2 == "2.2 Product"}
                 /* ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}
                  changeSidebarVisibility={changeSidebarVisibility}
                >
                  {this.state.showBrand &&
                    <SidebarCategory
                      title="Product Brand"
                      changeSidebarVisibility={changeSidebarVisibility}
                      collapse={this.state.expandedItemlevel3 == "Product Brand"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}

                    >
                      {this.state.show_brand_upload && (
                        <SidebarLink
                          title="Upload"
                          route="/upload/upload_brand_master"
                          onClick={this.hideSidebar}
                        />

                      )}

                      {this.state.show_brand_view && (
                        <SidebarLink
                          title="View"
                          route="/upload/view_brand_master"
                          onClick={this.hideSidebar}
                        />
                      )}
                    </SidebarCategory>
                  }


                  {this.state.alternateProduct &&
                    <SidebarCategory
                      title="Alternate Product"
                      changeSidebarVisibility={changeSidebarVisibility}
                      collapse={this.state.expandedItemlevel3 == "Alternate Product"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}

                    >
                      {this.state.alternateCreate && (
                        <SidebarLink
                          title="Upload"
                          route="/upload/alternate_product_create"
                          onClick={this.hideSidebar}
                        />

                      )}

                      {this.state.alternateView && (
                        <SidebarLink
                          title="View"
                          route="/upload/alternate_product_view"
                          onClick={this.hideSidebar}
                        />
                      )}
                    </SidebarCategory>
                  }




                  {this.state.showCategory &&
                    <SidebarCategory
                      title="Category"
                      collapse={this.state.expandedItemlevel3 == "Category"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}

                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_category_upload && (
                        <SidebarLink
                          title="Upload"
                          route="/upload/upload_category_master"
                          onClick={this.hideSidebar}
                        />

                      )}

                      {this.state.show_category_view && (


                        <SidebarLink
                          title="View"
                          route="/upload/view_category_master"
                          onClick={this.hideSidebar}
                        />


                      )}
                    </SidebarCategory>
                  }

                  {this.state.showSubCategory &&
                    <SidebarCategory
                      title="Sub Category"
                      collapse={this.state.expandedItemlevel3 == "Sub Category"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_sub_category_upload && (

                        <SidebarLink
                          title="Upload"
                          route="/upload/upload_product_sub_category_master"
                          onClick={this.hideSidebar}
                        />


                      )}

                      {this.state.show_sub_category_view && (


                        <SidebarLink
                          title="View"
                          route="/upload/view_product_sub_category_master"
                          onClick={this.hideSidebar}
                        />


                      )}
                    </SidebarCategory>
                  }


                  {this.state.showSubDivision &&
                    <SidebarCategory
                      title="Sub Division"
                      collapse={this.state.expandedItemlevel3 == "Sub Division"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_sub_division_upload && (


                        <SidebarLink
                          title="Upload"
                          route="/upload/upload_product_validation_master"
                          onClick={this.hideSidebar}
                        />



                      )}

                      {this.state.show_sub_division_view && (

                        <SidebarLink
                          title="View"
                          route="/upload/view_product_validation_master"
                          onClick={this.hideSidebar}
                        />

                      )}
                    </SidebarCategory>
                  }

                  {this.state.showSKU7Code &&
                    <SidebarCategory
                      title="SKU7 Code"
                      collapse={this.state.expandedItemlevel3 == "SKU7 Code"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_sku7_upload && (

                        <SidebarLink
                          title="Upload"
                          route="/upload/upload_sku7_master"
                          onClick={this.hideSidebar}
                        />
                      )}

                      {this.state.show_sku7_view && (

                        <SidebarLink
                          title="View"
                          route="/upload/view_sku7_master"
                          onClick={this.hideSidebar}
                        />


                      )}
                    </SidebarCategory>
                  }
                  {this.state.showShelfLife &&
                    <SidebarCategory
                      title="Shelf Life"
                      collapse={this.state.expandedItemlevel3 == "Shelf Life"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_shelf_life_upload && (

                        <SidebarLink
                          title="Upload"
                          route="/upload/upload_product_shelf_life"
                          onClick={this.hideSidebar}
                        />
                      )}

                      </SidebarCategory>
  }



                  {this.state.showSKU7Ean &&
                    <SidebarCategory
                      title="SKU7 EAN"
                      collapse={this.state.expandedItemlevel3 == "SKU7 EAN"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_sku7_ean_upload && (


                        <SidebarLink
                          title="Upload"
                          route="/upload/upload_sku_mrp_Master"
                          onClick={this.hideSidebar}
                        />

                      )}

                      {this.state.show_sku7_ean_view && (
                        <SidebarLink
                          title="View"
                          route="/upload/view_sku_mrp_Master"
                          onClick={this.hideSidebar}
                        />

                      )}
                    </SidebarCategory>
                  }

                  {this.state.showSKU7ChildProduct &&
                    <SidebarCategory
                      title="SKU7 Child Product"
                      collapse={this.state.expandedItemlevel3 == "SKU7 Child Product"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_sku7_child_product_upload && (

                        <SidebarLink
                          title="Upload"
                          route="/upload/upload_child_sku_master"
                          onClick={this.hideSidebar}
                        />

                      )}

                      {this.state.show_sku7_child_product_view && (

                        <SidebarLink
                          title="View"
                          route="/upload/view_child_sku_master"
                          onClick={this.hideSidebar}
                        />

                      )}
                    </SidebarCategory>
                  }



                  {this.state.showBasepack &&
                    <SidebarCategory
                      title="Basepack"
                      collapse={this.state.expandedItemlevel3 == "Basepack"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_basepack_upload && (

                        <SidebarLink
                          title="Upload"
                          route="/upload/basepack_form_update"
                          onClick={this.hideSidebar}
                        />

                      )}

                      {this.state.show_basepack_view && (

                        <SidebarLink
                          title="View"
                          route="/upload/view_basepack_master_form"
                          onClick={this.hideSidebar}
                        />


                      )}
                    </SidebarCategory>
                  }


                  {this.state.showCombinedProduct &&
                    <SidebarCategory
                      title="Combined Product"
                      collapse={this.state.expandedItemlevel3 == "Combined Product"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_combined_product_upload && (


                        <SidebarLink
                          title="Upload"
                          route="/upload/combined_product_form_update"
                          onClick={this.hideSidebar}
                        />


                      )}

                      {this.state.show_combined_product_view && (
                        <SidebarLink
                          title="View"
                          route="/upload/view_combined_product_master_form"
                          onClick={this.hideSidebar}
                        />

                      )}
                    </SidebarCategory>
                  }

                  {this.state.showPackaging &&
                    <SidebarCategory
                      title="Packaging"
                      collapse={this.state.expandedItemlevel3 == "Packaging"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}

                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_packaging_upload && (

                        <SidebarLink
                          title="Packaging Master"
                          route="/upload/packing_master_form_update"
                          onClick={this.hideSidebar}
                        />

                      )}

                      {this.state.show_packaging_view && (

                        <SidebarLink
                          title="View Packaging Master"
                          route="/upload/view_packaging_master_form"
                          onClick={this.hideSidebar}
                        />



                      )}
                    </SidebarCategory>
                  }

                  {this.state.showLBProduct &&
                    <SidebarCategory
                      title="LB Product"
                      collapse={this.state.expandedItemlevel3 == "LB Product"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}

                      changeSidebarVisibility={changeSidebarVisibility}
                    >


                      {this.state.show_lb_product_view && (


                        <SidebarLink
                          title="View"
                          route="/upload/view_lb_product_master_form"
                          onClick={this.hideSidebar}
                        />


                      )}
                    </SidebarCategory>
                  }

                  {this.state.item_master && (


                        <SidebarLink
                          title="Item Master"
                          route="/upload/item_master"
                          onClick={this.hideSidebar}
                        />


                      )}




                </SidebarCategory>
              }


              {this.state.showStore &&
                <SidebarCategory
                  title="2.3 Store"
                  collapse={this.state.expandedItemlevel2 == "2.3 Store"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >
                  {this.state.showRetailerCode &&
                    <SidebarCategory
                      title="Retailer Code"
                      collapse={this.state.expandedItemlevel3 == "Retailer Code"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}

                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_retailer_code_upload && (
                        <SidebarLink
                          title="Upload"
                          route="/upload/retailer_master_form_update"
                          onClick={this.hideSidebar}
                        />


                      )}

                      {this.state.show_retailer_code_view && (

                        <SidebarLink
                          title="View"
                          route="/upload/view_retailer_master_form"
                          onClick={this.hideSidebar}
                        />
                      )}
                    </SidebarCategory>
                  }


                  {this.state.showOutletCode &&
                    <SidebarCategory
                      title="Outlet Code"
                      collapse={this.state.expandedItemlevel3 == "Outlet Code"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_outlet_code_upload && (
                        <SidebarLink
                          title="Upload"
                          route="/upload/outlet_master_form_update"
                          onClick={this.hideSidebar}
                        />

                      )}

                      {this.state.show_outlet_code_view && (

                        <SidebarLink
                          title="View"
                          route="/upload/view_outlet_master_form"
                          onClick={this.hideSidebar}
                        />

                      )}
                    </SidebarCategory>
                  }

                  {this.state.showAreaCode &&
                    <SidebarCategory
                      title="Area Code"
                      collapse={this.state.expandedItemlevel3 == "Area Code"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_area_code_upload && (

                        <SidebarLink
                          title="Upload"
                          route="/upload/area_master_form_update"
                          onClick={this.hideSidebar}
                        />



                      )}

                      {this.state.show_area_code_view && (



                        <SidebarLink
                          title="View"
                          route="/upload/view_area_master_form"
                          onClick={this.hideSidebar}
                        />


                      )}
                    </SidebarCategory>
                  }

                   {this.state.showBeatAreaCode &&
                    <SidebarCategory
                      title="Beat Area Code"
                      collapse={this.state.expandedItemlevel3 == "Beat Area Code"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_beat_area_code_upload && (

                        <SidebarLink
                          title="Upload"
                          route="/upload/beat_area_master_form_update"
                          onClick={this.hideSidebar}
                        />



                      )}

                      {this.state.show_beat_area_code_view && (



                        <SidebarLink
                          title="View"
                          route="/upload/view_beat_area_master_form"
                          onClick={this.hideSidebar}
                        />


                      )}
                    </SidebarCategory>
                  }


                  {this.state.showRetailerAreaMapping &&
                    <SidebarCategory
                      title="Ret Area Mapping"
                      collapse={this.state.expandedItemlevel3 == "Ret Area Mapping"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_retailer_area_mapping_upload && (

                        <SidebarLink
                          title="Upload"
                          route="/upload/hul_area_master_form_update"
                          onClick={this.hideSidebar}
                        />

                      )}

                      {this.state.show_retailer_area_mapping_view && (

                        <SidebarLink
                          title="View"
                          route="/upload/view_hul_master_form"
                          onClick={this.hideSidebar}
                        />


                      )}
                    </SidebarCategory>
                  }

                  {this.state.showRetailerOCLDMapping &&
                    <SidebarCategory
                      title="Ret OCLD Mapping"
                      collapse={this.state.expandedItemlevel3 == "Ret OCLD Mapping"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_retailer_ocld_mapping_upload && (

                        <SidebarLink
                          title="Upload"
                          route="/upload/retailer_ocld_master_form_update"
                          onClick={this.hideSidebar}
                        />
                      )}

                    </SidebarCategory>
                  }



                  {this.state.showRetailerProductOCLDMapping &&
                    <SidebarCategory
                      title="Ret Prod OCLD Mapping"
                      collapse={this.state.expandedItemlevel3 == "Ret Prod OCLD Mapping"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_retailer_product_ocld_mapping_upload && (

                        <SidebarLink
                          title="Upload"
                          route="/upload/retailer_product_master_form_update"
                          onClick={this.hideSidebar}
                        />


                      )}

                    </SidebarCategory>
                  }

                  {this.state.retailerDCMapping && (
                    <SidebarLink
                      title="Retailer - CD Mapping"
                      route="/receiving/retailer_dc_mapping"
                      onClick={this.hideSidebar}
                    />
                  )}

                </SidebarCategory>
              }

              {this.state.showWH_INIT &&
                <SidebarCategory
                  title="2.4 WH INIT"
                  collapse={this.state.expandedItemlevel2 == "2.4 WH INIT"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}
                  changeSidebarVisibility={changeSidebarVisibility}
                >
                  {this.state.showWarehouseMaster &&
                    <SidebarCategory
                      title="Warehouse Master"
                      collapse={this.state.expandedItemlevel3 == "Warehouse Master"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_warehouse_master && (
                        <SidebarLink
                          title="View"
                          route="/upload/view_warehouse_master"
                          onClick={this.hideSidebar}
                        />
                      )}
                    </SidebarCategory>
                  }
                  {this.state.showCityMaster &&
                    <SidebarCategory
                      title="City Master"
                      collapse={this.state.expandedItemlevel3 == "City Master"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}
                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_city_master && (
                        <SidebarLink
                          title="View"
                          route="/upload/view_city_master"
                          onClick={this.hideSidebar}
                        />
                      )}
                    </SidebarCategory>
                  }
                  {this.state.showBrandMaster &&
                    <SidebarCategory
                      title="Brand Master"
                      collapse={this.state.expandedItemlevel3 == "Brand Master"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}

                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_brand_master && (
                        <SidebarLink
                          title="View"
                          route="/upload/view_new_brand_master"
                          onClick={this.hideSidebar}
                        />
                      )}
                    </SidebarCategory>
                  }
                  {this.state.showInventoryOwner &&
                    <SidebarCategory
                      title="Inventory Owner"
                      collapse={this.state.expandedItemlevel3 == "Inventory Owner"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}

                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_inventory_owner && (
                        <SidebarLink
                          title="View"
                          route="/upload/view_inventory_owner"
                          onClick={this.hideSidebar}
                        />
                      )}
                    </SidebarCategory>
                  }


                  {this.state.showZoneMaster &&
                    <SidebarCategory
                      title="Zone Master"
                      collapse={this.state.expandedItemlevel3 == "Zone Master"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}

                      changeSidebarVisibility={changeSidebarVisibility}
                    >
                      {this.state.show_zone_master && (
                        <SidebarLink
                          title="View"
                          route="/upload/view_zone_master"
                          onClick={this.hideSidebar}
                        />
                      )}
                    </SidebarCategory>
                  }

                </SidebarCategory>}


            </SidebarCategory>
          </ul>
        )}

        {this.state.inbound && (
          <ul
            className="sidebar__block"
            style={{ borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8 }}
          >
            <SidebarCategory
              title="3. Inbound"
              collapse={this.state.expandedItemlevel1 == "3. Inbound"}
              //ontoggle={this.toggleLevel1}
              ontoggle={(title) => this.toggleLevel1(title)}
              //getTitle={(title) => console.log(title)}
              icon={faTruck}
              changeSidebarVisibility={changeSidebarVisibility}
            >

            {this.state.showPurchaseOrder && (
                    <SidebarLink
                      title="Purchase Order"
                      route="/receiving/purchase_order"
                      onClick={this.hideSidebar}
                    />
              )} 
              {this.state.showReceiving &&
                <SidebarCategory
                  title="3.1 Receiving"
                  collapse={this.state.expandedItemlevel2 == "3.1 Receiving"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}
                  changeSidebarVisibility={changeSidebarVisibility}
                >
                  {this.state.uploadPrimaryUpload && (
                    <SidebarLink
                      title="Upload"
                      route="/receiving/primaryupload"
                      onClick={this.hideSidebar}
                    />
                  )} {this.state.createInboundDelivery && (
                    <SidebarLink
                      title="Create Inbound Delivery"
                      route="/receiving/create_Inbound_Delivery"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.createASN && (
                    <SidebarLink
                      title="Create ASN"
                      route="/receiving/create_ASN"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.sendToHHT && (
                    <SidebarLink
                      title="Send To HHT"
                      route="/receiving/send_to_hht"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.POSortClose && (
                    <SidebarLink
                      title="Receiving Short Close"
                      route="/receiving/po_sorting"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {/* {this.state.createInboundDelivery && (
                <SidebarLink
                  title="Create Inbound Delivery"
                  route="/receiving/create_Inbound_Delivery"
                  onClick={this.hideSidebar}
                />
              )}*/}

                  {this.state.dashboardPrimaryUpload && (
                    <SidebarLink
                      title="Assign User"
                      route="/receiving/assign_user"
                      onClick={this.hideSidebar}
                    />
                  )}



                  {/* {this.state.viewInboundDelivery && (
                <SidebarLink
                  title="View Inbound Delivery"
                  route="/receiving/view_inbound"
                  onClick={this.hideSidebar}
                />
              )}*/}

                  {this.state.showPendingDataUpload && (

                    <SidebarLink
                      title="Pending Data Upload"
                      route="/receiving/upload_pending_data"
                      onClick={this.hideSidebar}
                    />
                  )}


                  {this.state.showInboundReceiving && (

                    <SidebarLink
                      title="Inbound Receiving"
                      route="/receiving/inbound_receiving"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showMissingProduct && (
                    <SidebarLink
                      title="Missing Product"
                      route="/receiving/view_missing_product"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showMissingUpdate && (
                    <SidebarLink
                      title="Update Missing Product"
                      route="/receiving/missing_product_info"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showMismatch && (
                    <SidebarLink
                      title="View Mismatch"
                      route="/receiving/view_mismatch"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showExcess && (
                    <SidebarLink
                      title="View Excess"
                      route="/receiving/view_excess"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.PurchaseReturn && (
                    <SidebarLink
                      title="Purchase Return"
                      route="/receiving/purchase_return"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.BulkPurchaseReturn && (
                    <SidebarLink
                      title="Bulk Purchase Return"
                      route="/receiving/bulk_purchase_return"
                      onClick={this.hideSidebar}
                    />
                  )}


                  {this.state.PurchaseReturnApproval && (
                    <SidebarLink
                      title="Purchase Return Approval"
                      route="/receiving/purchase_return_approval"
                      onClick={this.hideSidebar}
                    />
                  )}

                   {this.state.POCreation && (
                    <SidebarLink
                      title="PO Creation"
                      route="/receiving/p0_creation"
                      onClick={this.hideSidebar}
                    />
                  )}




                  {/*<SidebarLink
                  title="Split Crate"
                  route="/receiving/split_crate"
                  onClick={this.hideSidebar}
                />*/}
                </SidebarCategory>

              }


              {this.state.showPutaway &&
                <SidebarCategory
                  title="3.2 Put-Away"
                  collapse={this.state.expandedItemlevel2 == "3.2 Put-Away"}
                  /*ontoggle={this.toggleLevel2}
*/  
                    ontoggle={(title) => this.toggleLevel2(title)}
                    changeSidebarVisibility={changeSidebarVisibility}
                >
                  {this.state.create_putaway && (
                    <SidebarLink
                      title="Create Task"
                      route="/putaway/uploadgrn"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.assign_putaway && (
                    <SidebarLink
                      title="Assign Task"
                      route="/putaway/printPutaway"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.allocate_putaway && (
                    <SidebarLink
                      title="Allocate Task"
                      route="/putaway/printtPutaway"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.print_putaway && (
                    <SidebarLink
                      title="Print Task"
                      route="/putaway/printDetail"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.confirm_putaway && (
                    <SidebarLink
                      title="Confirm Task"
                      route="/putaway/confirmputawayform"
                      onClick={this.hideSidebar}
                    />
                  )}
                </SidebarCategory>
              }

            </SidebarCategory>
          </ul>
        )}


        {/* <ul
            className="sidebar__block"
            style={{ borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8 }}
          >
          
            <SidebarCategory
              title="Picking"
              icon={faDolly}
              changeSidebarVisibility={changeSidebarVisibility}
            >
              {this.state.create_picking && (
                <SidebarLink
                  title="Create Task"
                  route="/picking/picksheet_upload"
                  onClick={this.hideSidebar}
                />
              )}

              
              {this.state.confirmed_tester_picking && (
                <SidebarLink
                  title="Confirmed Tester"
                  route="/picking/testerConfirmation"
                  onClick={this.hideSidebar}
                />
              )}

              {this.state.confirm_dispatch_picking && (
                <SidebarLink
                  title="Confirm Dispatch"
                  route="/picking/dispatchConfirmation"
                  onClick={this.hideSidebar}
                />
              )}
              
            </SidebarCategory>
          </ul>*/}


        {/*<ul className="sidebar__block" style={{borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8}}>
          <SidebarCategory title="Picking" icon={faDolly} changeSidebarVisibility={changeSidebarVisibility}>
            <SidebarLink title="Create Task" route="/picking/picksheet_upload" onClick={this.hideSidebar} />
            <SidebarLink title="Assign Task" route="/picking/printPickingSheet" onClick={this.hideSidebar} />
            <SidebarLink title="Print Task" route="/picking/printPickingDetail" onClick={this.hideSidebar} />
            <SidebarLink title="Confirm Task" route="/picking/pickingConfirmation" onClick={this.hideSidebar} />
            <SidebarLink title="Confirmed Tester" route="/picking/testerConfirmation" onClick={this.hideSidebar} />
            <SidebarLink title="Confirm Dispatch" route="/picking/dispatchConfirmation" onClick={this.hideSidebar} />
            <SidebarLink title="Cancel Task" route="/picking/pickingCancellation" onClick={this.hideSidebar} />
          </SidebarCategory>
        </ul>*/}

        {/*<ul className="sidebar__block" style={{borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8}}>
          <SidebarCategory title="Stock Management" icon={faWarehouse} changeSidebarVisibility={changeSidebarVisibility}>
            <SidebarLink title="Stock Movement" route="/stockManagement/stockMovement" onClick={this.hideSidebar} />
          </SidebarCategory>
        </ul>*/}

        {this.state.outbond &&

          <ul
            className="sidebar__block"
            style={{ borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8 }}
          >
            <SidebarCategory
              title="4. Outbound"
              collapse={this.state.expandedItemlevel1 == "4. Outbound"}
             /* ontoggle={this.toggleLevel1}*/
              ontoggle={(title) => this.toggleLevel1(title)}
              icon={faFile}
              changeSidebarVisibility={changeSidebarVisibility}
            >

              {this.state.showOrders &&
                <SidebarCategory
                  title="4.1 Orders"
                  collapse={this.state.expandedItemlevel2 == "4.1 Orders"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}
                  changeSidebarVisibility={changeSidebarVisibility}
                >
                  {this.state.showOrderUpload &&
                    <SidebarLink
                      title="Order Upload"
                      route="/secondaryupload/upload"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.showBillUpload &&
                    <SidebarLink
                      title="Bill Upload"
                      route="/secondaryupload/bill_number_upload"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showBillDataDashboard &&
                    <SidebarLink
                      title="Bill Data Dashboard"
                      route="/secondaryupload/bill_data_dashboard"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.showBillDataDashboardNew &&
                    <SidebarLink
                      title="Bill Data Dashboard New"
                      route="/secondaryupload/bill_data_dashboard_new"
                      onClick={this.hideSidebar}
                    />
                  }




                  {this.state.showUploadedOrdersBills &&
                    <SidebarLink
                      title="Uploaded Orders/ Bills"
                      route="/secondaryupload/view_task"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showErrorInUpload &&
                    <SidebarLink
                      title="Error in Upload"
                      route="/secondaryupload/error_report"
                      onClick={this.hideSidebar}
                    />
                  }


                  {this.state.showGroupOrdersBill &&
                    <SidebarCategory
                      title="Group  Orders/Bills"
                      collapse={this.state.expandedItemlevel3 == "Group  Orders/Bills"}
                      /*ontoggle={this.toggleLevel3}*/
                      ontoggle={(title) => this.toggleLevel3(title)}

                      changeSidebarVisibility={changeSidebarVisibility}
                    >

                      {this.state.showCreateGroup &&
                        <SidebarLink
                          title="Create Group"
                          route="/secondaryupload/create_group"
                          onClick={this.hideSidebar}
                        />
                      }

                      {this.state.showViewGroup &&

                        <SidebarLink
                          title="View Group"
                          route="/secondaryupload/view_group"
                          onClick={this.hideSidebar}
                        />
                      }

                      {this.state.showAllocateInventory &&

                        <SidebarLink
                          title="Allocate Inventory"
                          route="/secondaryupload/dashboard"
                          onClick={this.hideSidebar}
                        />
                      }


                    </SidebarCategory>
                  }

                </SidebarCategory>
              }






              {this.state.showPicking &&
                <SidebarCategory
                  title="4.2 Picking"
                  collapse={this.state.expandedItemlevel2 == "4.2 Picking"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}
                  changeSidebarVisibility={changeSidebarVisibility}
                >



                  {this.state.showViewTask &&
                    <SidebarLink
                      title="View Task"
                      route="/secondaryupload/task_view"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showOrderView &&
                    <SidebarLink
                      title=" Order View"
                      route="/secondaryupload/packing_order_view"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showPickPackPlanning &&
                    <SidebarLink
                      title="Pick & Pack Planning"
                      route="/secondaryupload/manual_ptl"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showSendToPackingStation &&
                    <SidebarLink
                      title=" Send to Packing Station"
                      route="/secondaryupload/packing_dash_view"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showUpdateEan &&
                    <SidebarLink
                      title="Update Ean"
                      route="/secondaryupload/update_ean"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showPickingAssignTask &&
                    <SidebarLink
                      title="Assign Task"
                      route="/picking/printPickingSheet"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showPickingPrintTask &&

                    <SidebarLink
                      title="Print Tasks"
                      route="/picking/printPickingDetail"
                      onClick={this.hideSidebar}
                    />


                  }

                  {this.state.showPickingConfirmTask1 &&


                    <SidebarLink
                      title="Confirm Tasks"
                      route="/picking/pickingConfirmation"
                      onClick={this.hideSidebar}
                    />

                  }

                  {this.state.showPickingCancelTask &&
                    <SidebarLink
                      title="Cancel Task"
                      route="/picking/pickingCancellation"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showLooseCLDConfirmation &&
                    <SidebarLink
                      title="Loose and CLD Confirmation"
                      route="/secondaryupload/cld_loose_confirm"
                      onClick={this.hideSidebar}
                    />
                  }


                  {this.state.showBillwisePicksheet &&
                    <SidebarLink
                      title="Billwise Picksheet"
                      route="/secondaryupload/bill_wise_picksheet"
                      onClick={this.hideSidebar}
                    />
                  }


                  {this.state.showPickingTracking &&
                    <SidebarLink
                      title="Picking Tracking"
                      route="/picking/pickingTracking"
                      onClick={this.hideSidebar}
                    />
                  }

                   {this.state.showPickingPrioritization &&
                    <SidebarLink
                      title="Picking Priority"
                      route="/picking/pickingPrioritization"
                      onClick={this.hideSidebar}
                    />
                  }

                  {/*<SidebarLink
                  title=" Create PTL"
                  route="/secondaryupload/create_ptl"
                  onClick={this.hideSidebar}
                />

                 <SidebarLink
                  title=" Create Master PTL"
                  route="/secondaryupload/create_master_ptl"
                  onClick={this.hideSidebar}
                />*/}













                </SidebarCategory>
              }


              {this.state.showPacking &&
                <SidebarCategory
                  title="4.3 Packing"
                  collapse={this.state.expandedItemlevel2 == "4.3 Packing"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}
                  changeSidebarVisibility={changeSidebarVisibility}
                >



                  {this.state.showPackingEdit &&
                    <SidebarLink
                      title="Packing Edit"
                      route="/secondaryupload/edit_ptl"
                      onClick={this.hideSidebar}
                    />
                  }


                  {this.state.showBillReUpload &&
                    <SidebarLink
                      title="Bill Re-Upload"
                      route="/secondaryupload/bill_number_reupload"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showBillEditConfig &&
                    <SidebarLink
                      title="Bill Edit Conf"
                      route="/secondaryupload/bill_bypass"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showPTLBYPASS &&
                    <SidebarLink
                      title="PTL By Pass"
                      route="/secondaryupload/ptl_by_pass"
                      onClick={this.hideSidebar}
                    />

                  }

                  {this.state.showPtlToPackingConfig &&
                    <SidebarLink
                      title="Switch PTL To Packing App"
                      route="/secondaryupload/ptl_to_packing"
                      onClick={this.hideSidebar}
                    />
                  }






                  {/*<SidebarLink
                  title=" Party View"
                  route="/secondaryupload/party_view"
                  onClick={this.hideSidebar}
                />*/}

                </SidebarCategory>
              }


              {this.state.showDispatch &&
                <SidebarCategory
                  title="4.4 Dispatch"
                  collapse={this.state.expandedItemlevel2 == "4.4 Dispatch"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}
                  changeSidebarVisibility={changeSidebarVisibility}
                >



                  {this.state.showVanPlanning &&
                    <SidebarLink
                      title="Van Planning"
                      route="/secondaryupload/create_van_planning"
                      onClick={this.hideSidebar}
                    />
                  }


                  {this.state.showReadyToDispatch &&
                    <SidebarLink
                      title=" Ready To Dispatch"
                      route="/secondaryupload/van_dashboard"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showDispatchConfirmation &&
                    <SidebarLink
                      title="Dispatch Confirmation"
                      route="/secondaryupload/dispatch_confirm"
                      onClick={this.hideSidebar}

                    />
                  }
                  {this.state.showManualHandover &&
                    <SidebarLink
                      title=" Manual Handover"
                      route="/secondaryupload/manual_handover"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.showTripPlanning &&
                    <SidebarLink
                      title=" Trip Planning"
                      route="/secondaryupload/trip_planning"
                      onClick={this.hideSidebar}
                    />
                  }


                  {/*<SidebarLink
                  title=" Party View"
                  route="/secondaryupload/party_view"
                  onClick={this.hideSidebar}
                />*/}





                </SidebarCategory>
              }



            </SidebarCategory>
          </ul>
        }


        {this.state.maintenance && (
          <ul
            className="sidebar__block"
            style={{ borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8 }}
          >
            <SidebarCategory
              title="6. Maintenance"
              collapse={this.state.expandedItemlevel1 == "6. Maintenance"}
              /*ontoggle={this.toggleLevel1}*/
              ontoggle={(title) => this.toggleLevel1(title)}
              icon={faWrench}
              changeSidebarVisibility={changeSidebarVisibility}
            >
              {/*<SidebarLink title="Bin Consolidation" route="/maintenance/BinconsolidationDashboard" onClick={this.hideSidebar} />*/}
              {this.state.cycle_count && (
                <SidebarLink
                  title="6.1 Cycle Count"
                  route="/maintenance/cycleCount/assignUser"
                  onClick={this.hideSidebar}
                />
              )}
              {this.state.customer_vs_sap && (
                <SidebarLink
                  title="6.2 Customer vs WMS Inventory"
                  route="/maintenance/Customervswmsinvetory"
                  onClick={this.hideSidebar}
                />
              )}



              {this.state.cycle_count_approval && (
                <SidebarLink
                  title="6.3 Cycle Count Approval"
                  route="/maintenance/cycleCount/cycleCountApproval"
                  onClick={this.hideSidebar}
                />
              )}

               {this.state.cycle_count_approval_new && (
                <SidebarLink
                  title="6.5 CC Approval-Finance"
                  route="/maintenance/cycleCount/cycleCountApprovalNew"
                  onClick={this.hideSidebar}
                />
              )}
              {this.state.stock_transfer && (
                <SidebarLink
                  title="6.4 Stock Transfer"
                  route="/maintenance/stock_transfer"
                  onClick={this.hideSidebar}
                />
              )}

              {/* {this.state.showStockMovementNew && (
                <SidebarLink
                  title="6.6 Stock Movement New"
                  route="/maintenance/stockMovementNew"
                  onClick={this.hideSidebar}
                />
              )}*/}

              {this.state.showStockMovementMain && (

                <SidebarCategory1
                  title="6.5 Stock Movement"
                  collapse={this.state.expandedItemlevel2 == "6.5 Stock Movement"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}
                  className="toggleLevel2"
                  changeSidebarVisibility={changeSidebarVisibility}
                >

                  {this.state.stock_movement && (
                    <SidebarLink
                      title="6.5.1 To Dmg/Exp"
                      route="/maintenance/stockMovementNew"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.stock_movement_lakme && (
                    <SidebarLink
                      title="6.5.2 To Good"
                      route="/maintenance/stockMovement"
                      onClick={this.hideSidebar}
                    />
                  )}


                  {this.state.showStockMovementApproval && (
                    <SidebarLink
                      title="6.5.3 Approval"
                      route="/maintenance/stockMovementApproval"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.stock_movement_to_good && (
                    <SidebarLink
                      title="6.5.4 Dmg/Exp To Good"
                      route="/Maintenance/stockMovement_dmgtogood"
                      onClick={this.hideSidebar}
                    />
                  )}



                </SidebarCategory1>
              )}
              {this.state.showStiUpdate && (
                <SidebarLink
                  title="6.6 STI Update"
                  route="/maintenance/sti_update"
                  onClick={this.hideSidebar}
                />
              )}
              {this.state.stocktransferuploader && (
                <SidebarLink
                  title="6.7 Stock Transfer Uploader"
                  route="/maintenance/stock_transfer_uploader"
                  onClick={this.hideSidebar}
                />
              )}

            </SidebarCategory>
          </ul>
        )}

        {this.state.reports && (
          <ul
            className="sidebar__block"
            style={{ borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8 }}
          >
            <SidebarCategory
              title="7. Reports"
              collapse={this.state.expandedItemlevel1 == "7. Reports"}
             /* ontoggle={this.toggleLevel1}*/
              ontoggle={(title) => this.toggleLevel1(title)}
              icon={faFile}
              changeSidebarVisibility={changeSidebarVisibility}
            >

              {this.state.showTransactionstatus &&
                <SidebarLink
                  title="Transaction Status"
                  route="/wmsReports/transaction_status_report"
                  onClick={this.hideSidebar}
                />
              }

               {this.state.showinboundReport &&
                <SidebarLink
                  title="Inbound Reports"
                  route="/wmsReports/inbound_reports"
                  onClick={this.hideSidebar}
                />
              }

               {this.state.showoutboundReport &&
                <SidebarLink
                  title="Outbound Reports"
                  route="/wmsReports/outbound_reports"
                  onClick={this.hideSidebar}
                />
              }
             {/* {this.state.showinboundReport &&
                <SidebarCategory
                  title="7.1 Inbound"
                  collapse={this.state.expandedItemlevel2 == "7.1 Inbound"}
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >


                 
                  {this.state.showHealthCheckReport &&
                    <SidebarLink
                      title="Health Check Report"
                      route="/wmsReports/health_check_report"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.showPOToGRN &&
                    <SidebarLink
                      title="PO to GRN"
                      route="/wmsReports/po_to_grn_report"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.showPOShortReport &&
                    <SidebarLink
                      title="Receiving Short Report"
                      route="/wmsReports/po_sort_report"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.showPurchseOrder &&
                    <SidebarLink
                      title="Purchase Order(PO)"
                      route="/wmsReports/purchase"
                      onClick={this.hideSidebar}
                    />}
                    {this.state.showInboundDeliveryReport &&
                    <SidebarLink
                      title="Inbound Delivery"
                      route="/wmsReports/inbound_delivery"
                      onClick={this.hideSidebar}
                    />}
                  {this.state.showAsnReport &&
                    <SidebarLink
                      title="ASN/ Invoice"
                      route="/wmsReports/asn_invoice"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.showReceivingReport &&
                    <SidebarLink
                      title="Receiving"
                      route="/wmsReports/receiving"
                      onClick={this.hideSidebar}
                    />}
                  {this.state.showSalesReturnReport &&
                    <SidebarLink
                      title="Sales Return"
                      route="/wmsReports/sales_return"
                      onClick={this.hideSidebar}
                    />}
                  {this.state.salesReturnGr &&
                    <SidebarLink
                      title="Sales Return To Gr"
                      route="/wmsReports/sales_return_gr"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.purchase_return_report &&
                    <SidebarLink
                      title="Purchase Return Report"
                      route="/wmsReports/purchase_return_report"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.putaway_report &&
                    <SidebarLink
                      title="Putaway Report"
                      route="/wmsReports/putaway_report"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.inbound_summary_report &&
                    <SidebarLink
                      title="Inbound Summary"
                      route="/wmsReports/inbound_summary_report"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.staging_report &&
                    <SidebarLink
                      title="Staging Report"
                      route="/wmsReports/staging_report"
                      onClick={this.hideSidebar}
                    />
                  }

                </SidebarCategory>



              }*/}

             {/* {this.state.showOutbondReport &&
                <SidebarCategory
                  title="7.2 Outbound"
                  collapse={this.state.expandedItemlevel2 == "7.2 Outbound"}
                 
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >

                  {this.state.showSoToDispatch && (
                    <SidebarLink
                      title="SO to Dispatch"
                      route="/secondaryupload/so_to_dispatch"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showPackingTaskReport && (
                    <SidebarLink
                      title="Packing Task Data"
                      route="/secondaryupload/packing_task_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showMasterPackingTaskReport && (
                    <SidebarLink
                      title="Master Packing Task Data"
                      route="/secondaryupload/master_packing_task_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showPTLIncremental && (
                    <SidebarLink
                      title="PTL Incremental"
                      route="/secondaryupload/incremental_data_report"
                      onClick={this.hideSidebar}
                    />

                  )}

                  {this.state.showPTLComplate && (
                    <SidebarLink
                      title="PTL Complete"
                      route="/secondaryupload/complete_data_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showPackingStationZoneMaster && (
                    <SidebarLink
                      title="Packing Station Zone Master report"
                      route="/secondaryupload/zone_master_report"
                      onClick={this.hideSidebar}
                    />

                  )}

                  {this.state.showPackingStationOrderMapping && (
                    <SidebarLink
                      title="Packing Station Order Mapping report"
                      route="/secondaryupload/order_mapping_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showPartyPackedReport && (
                    <SidebarLink
                      title="Party Packed Report"
                      route="/secondaryupload/party_packed_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showPtlApiReport && (
                    <SidebarLink
                      title="PTL API PUT Qty Report"
                      route="/secondaryupload/ptl_api_put_qty_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showMasterPtlDataReport && (
                    <SidebarLink
                      title="Master PTL Data Report"
                      route="/secondaryupload/master_ptl_data_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showPtlDataReport && (
                    <SidebarLink
                      title="PTL Data Report"
                      route="/secondaryupload/ptl_data_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showDispatchConfirmReport && (
                    <SidebarLink
                      title="Dispatch Confirm Report"
                      route="/secondaryupload/dispatch_confirm_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showCompletedVansReport && (
                    <SidebarLink
                      title="Completed Vans Report"
                      route="/secondaryupload/completed_vans_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showBillEditingReport && (
                    <SidebarLink
                      title="Bill Editing Report"
                      route="/secondaryupload/bill_editing_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showBillOPCVanReport && (
                    <SidebarLink
                      title="Bill Report"
                      route="/secondaryupload/bill_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showDRSIdReport && (
                    <SidebarLink
                      title="DRS Box Id Report"
                      route="/secondaryupload/drs_box_id_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                  {this.state.showSODispatchReport && (
                    <SidebarLink
                      title="SO Dispatch Report"
                      route="/secondaryupload/so_dispatch_report"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.showInventoryAllocationReport && (
                    <SidebarLink
                      title="Inventory Allocation Report"
                      route="/wmsReports/inventory_allocation_report"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.showCldDispatchReport && (
                    <SidebarLink
                      title="CLD Dispatch Report"
                      route="/wmsReports/cld_dispatch_report"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.secondary_bifurcation &&
                    <SidebarLink
                      title="Secondary Bifurcation"
                      route="/wmsReports/bifurcation_report"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.billwise_to_case_picksheet_report &&
                    <SidebarLink
                      title="Billwise To Case Picksheet"
                      route="/wmsReports/billwise_to_case_picksheet_report"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.integration_report &&
                    <SidebarLink
                      title="Integration Report"
                      route="/wmsReports/integration_report"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.sto_transaction &&
                    <SidebarLink
                      title="STO Transaction Report"
                      route="/wmsReports/sto_transaction"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.dues_report &&
                    <SidebarLink
                      title="Dues Report"
                      route="/wmsReports/dues_report"
                      onClick={this.hideSidebar}
                    />
                  }


                  {this.state.showDRSCLDReport && (
                    <SidebarLink
                      title="DRS CLD Report"
                      route="/secondaryupload/drs_cld_report"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.mis_sto_report &&
                    <SidebarLink
                      title="STO Report"
                      route="/wmsReports/sto_report"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.bin_consolidation &&
                    <SidebarLink
                      title="Bin Consolidation Report"
                      route="/wmsReports/reports/binconsolidation"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.pick_task_report &&
                    <SidebarLink
                      title="Pick Task Report"
                      route="/wmsReports/pick_task_report"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.pending_order_vs_available_qty &&
                    <SidebarLink
                      title="Pending Order vs Available Qty"
                      route="/wmsReports/pending_order_vs_available_qty"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.packed_crate_report &&
                    <SidebarLink
                      title="Packed Crate Report"
                      route="/wmsReports/packed_crate_report"
                      onClick={this.hideSidebar}
                    />
                  }


                </SidebarCategory>
              }*/}

              {this.state.showInventoryReport &&
                <SidebarCategory
                  title="7.3 Inventory"
                  collapse={this.state.expandedItemlevel2 == "7.3 Inventory"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >

                  {this.state.inventory_report && (
                    <SidebarLink
                      title="Reports"
                      route="/wmsReports/inventoryReports"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.showLynkMandiStock_report && (
                    <SidebarLink
                      title="Lynk Mandi Stock Reports"
                      route="/wmsReports/lynk_mandi_stock_report"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.inventory_analysis_report && (
                    <SidebarLink
                      title="Inventory Allocation Analysis Reports"
                      route="/wmsReports/inventory_allocation_analysis_report"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.cycle_count_report && (
                    <SidebarLink
                      title="Cycle Count Reports"
                      route="/wmsReports/cycle_count_report"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.stock_movement_report && (
                    <SidebarLink
                      title="Stock Movement Reports"
                      route="/wmsReports/stock_movement"
                      onClick={this.hideSidebar}
                    />
                  )}

                </SidebarCategory>
              }

              {this.state.showInventoryReport &&
                <SidebarCategory
                  title="7.4 Daily Inventory"
                  collapse={this.state.expandedItemlevel2 == "7.4 Daily Inventory"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >

                  {this.state.inventory_report && (
                    <SidebarLink
                      title="Daily Reports"
                      route="/wmsReports/daily_inventoryReports"
                      onClick={this.hideSidebar}
                    />
                  )}

                </SidebarCategory>
              }

              {this.state.showStorageReport &&
                <SidebarCategory
                  title="7.5 Storage"
                  collapse={this.state.expandedItemlevel2 == "7.5 Storage"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >

                  {this.state.storage_report && (
                    <SidebarLink
                      title="Storage Reports"
                      route="/wmsReports/storageReports"
                      onClick={this.hideSidebar}
                    />
                  )}
                  {this.state.expiry_report && (
                    <SidebarLink
                      title="Products Expiry Reports"
                      route="/wmsReports/expiry_report"
                      onClick={this.hideSidebar}
                    />
                  )}

                </SidebarCategory>
              }


              {this.state.showTransactionReport &&
                <SidebarCategory
                  title="7.6 Transaction"
                  collapse={this.state.expandedItemlevel2 == "7.6 Transaction"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >
                  {this.state.transactional_report && (
                    <SidebarLink
                      title="Transactional Reports"
                      route="/wmsReports/transactionalReports"
                      onClick={this.hideSidebar}
                    />
                  )}
                </SidebarCategory>
              }
              {this.state.invoice_download &&
                <SidebarCategory
                  title="7.7 Invoice Reports"
                  collapse={this.state.expandedItemlevel2 == "7.7 Invoice Reports"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >
                  {this.state.transactional_report && (
                    <SidebarLink
                      title="Invoice Reports"
                      route="/wmsReports/invoice_download"
                      onClick={this.hideSidebar}
                    />
                  )}
                </SidebarCategory>
  }
            </SidebarCategory>
          </ul>
        )}


        {this.state.mis_report && (
          <ul
            className="sidebar__block"
            style={{ borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8 }}
          >

            <SidebarCategory
              title="9.1 MIS Reports"
              collapse={this.state.expandedItemlevel1 == "9.1 MIS Reports"}
              /*ontoggle={this.toggleLevel1}*/
              ontoggle={(title) => this.toggleLevel1(title)}
              icon={faFile}
              changeSidebarVisibility={changeSidebarVisibility}
            >
              {this.state.showERPVsJarvis &&
                <SidebarCategory
                  title="ERP Vs Jarvis Inventory"
                  collapse={this.state.expandedItemlevel2 == "ERP Vs Jarvis Inventory"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >

                  <SidebarLink
                    title="Item Level"
                    route="/wmsReports/brand_inventoryReports"
                    onClick={this.hideSidebar}
                  />

                  <SidebarLink
                    title="WH Brand Level"
                    route="/wmsReports/item_inventoryReports"
                    onClick={this.hideSidebar}
                  />
                  {this.state.intransit_inventory_level &&
                  <SidebarLink
                  title="In Transit Level"
                  route="/wmsReports/erp_jarvis_intransit_inventory_report"
                  onClick={this.hideSidebar}
                />
                  }



                </SidebarCategory>
              }


              {this.state.mis_inventory_movement &&

                <SidebarCategory
                  title="Inventory Movement"
                  collapse={this.state.expandedItemlevel2 == "Inventory Movement"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >

                  <SidebarLink
                    title="Item Level"
                    route="/wmsReports/inventory_movement_item"
                    onClick={this.hideSidebar}
                  />

                  <SidebarLink
                    title="WH Brand Level"
                    route="/wmsReports/inventory_movement_brand"
                    onClick={this.hideSidebar}
                  />
                  {this.state.intransit_transaction &&

                    <SidebarLink
                      title="Intransit Transaction Report"
                      route="/wmsReports/intransit/transaction"
                      onClick={this.hideSidebar}
                    />
                  }



                </SidebarCategory>
              }
              {this.state.mis_fill_rate_report &&
                <SidebarLink
                  title="Fill Rate Report"
                  route="/wmsReports/fill_rate_report"
                  onClick={this.hideSidebar}
                />
              }
              {this.state.new_mis_fill_rate_report &&
                <SidebarLink
                  title="FTR Report"
                  route="/wmsReports/new_fill_rate_report"
                  onClick={this.hideSidebar}
                />
              }


              {this.state.packed_vs_invoiced &&
                <SidebarLink
                  title="Packed VS Invoiced"
                  route="/wmsReports/packed_vs_invoiced"
                  onClick={this.hideSidebar}
                />
              }


              {this.state.mis_inbound &&

                <SidebarCategory
                  title="Inbound Transaction"
                  collapse={this.state.expandedItemlevel2 == "Inbound Transaction"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >

                  <SidebarLink
                    title="Purchase"
                    route="/wmsReports/mis_po_to_grn_report"
                    onClick={this.hideSidebar}
                  />

                  <SidebarLink
                    title="Sales Return"
                    route="/wmsReports/mis_sales_return_gr"
                    onClick={this.hideSidebar}
                  />



                </SidebarCategory>
              }

              {this.state.mis_outbound &&

                <SidebarCategory
                  title="Outbound Transaction"
                  collapse={this.state.expandedItemlevel2 == "Outbound Transaction"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >

                  <SidebarLink
                    title="Sales"
                    route="/wmsReports/mis_so_to_dispatch"
                    onClick={this.hideSidebar}
                  />
                  <SidebarLink
                    title="Packing Report"
                    route="/wmsReports/mis_packed_crate_report"
                    onClick={this.hideSidebar}
                  />
                  <SidebarLink
                    title="Packing Task - Detailed"
                    route="/wmsReports/mis_packing_report"
                    onClick={this.hideSidebar}
                  />

                </SidebarCategory>
              }

              {this.state.mis_cyclecount &&

                <SidebarCategory
                  title="Cycle count"
                  collapse={this.state.expandedItemlevel2 == "Cycle count"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >
                  {this.state.show_cc_adjustment &&
                    <SidebarLink
                      title="Cycle Count Adjustment"
                      route="/wmsReports/mis_cycle_count_report"
                      onClick={this.hideSidebar}
                    />
                  }

                  {this.state.show_cc_variance &&

                    <SidebarLink
                      title="CC National Variance"
                      route="/wmsReports/mis_cc_variance_report"
                      onClick={this.hideSidebar}
                    />
                  }

                </SidebarCategory>

              }
              {this.state.mis_transaction_failure &&

                <SidebarCategory
                  title="Transaction Level Failure"
                  collapse={this.state.expandedItemlevel2 == "Transaction Level Failure"}
                  /*ontoggle={this.toggleLevel2}*/
                  ontoggle={(title) => this.toggleLevel2(title)}

                  changeSidebarVisibility={changeSidebarVisibility}
                >
                  {this.state.show_cc_failure &&

                    <SidebarLink
                      title="CC Failure Report"
                      route="/wmsReports/cc_failure"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.show_invoice_failure &&

                    <SidebarLink
                      title="Invoice Failure Report"
                      route="/wmsReports/invoice_failure"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.show_inbound_failure &&

                    <SidebarLink
                      title="Inbound PO Failure Report"
                      route="/wmsReports/inbound_failure"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.show_inbound_srn_failure &&

                    <SidebarLink
                      title="Inbound SRN Failure Report"
                      route="/wmsReports/inbound_srn_failure"
                      onClick={this.hideSidebar}
                    />
                  }
                  {this.state.show_transaction_failure &&

                    <SidebarLink
                      title="Transaction Failure Report"
                      route="/wmsReports/transaction_failure"
                      onClick={this.hideSidebar}
                    />
                  }



                </SidebarCategory>
              }

              {this.state.mis_item_wise_transaction &&
                <SidebarLink
                  title="Item wise transaction"
                  route="/wmsReports/mis_item_wise_transaction"
                  onClick={this.hideSidebar}
                />
              }
              {this.state.showBillVSPackingReport && (
                <SidebarLink
                  title="Packing Station Summary"
                  route="/wmsReports/packing_station_summary"
                  onClick={this.hideSidebar}
                />
              )}
              {this.state.bin_to_bin_transfer && (
                    <SidebarLink
                      title="Bin To Bin Transfer"
                      route="/wmsReports/bin_transfer_report"
                      onClick={this.hideSidebar}
                    />
                  )}
              {this.state.mis_dispatch_pending &&(
                    <SidebarLink
                      title="Picked and Dispatch Diff"
                      route="/wmsReports/mis/dispatch_diff_report"
                      onClick={this.hideSidebar}
                    />
                  )}
              {this.state.mis_purchase_return &&(
                    <SidebarLink
                      title="Purchase Return"
                      route="/wmsReports/mis/purchase_return_report"
                      onClick={this.hideSidebar}
                    />
                  )}
              {this.state.mis_weighted_avg_report &&
                <SidebarLink
                  title="Weighted Avg Report"
                  route="/wmsReports/mis_weighted_avg_report"
                  onClick={this.hideSidebar}
                />
              }

              {this.state.mis_weighted_avg_report &&
                <SidebarLink
                  title="Weighted Avg Report"
                  route="/wmsReports/mis_weighted_avg_report"
                  onClick={this.hideSidebar}
                />
              }


            </SidebarCategory>
          </ul>
        )}

        {this.state.create_user &&(

        <ul className="sidebar__block" style={{borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8}}>
          <SidebarLink title="Create User" route="/receiving/create_user" onClick={this.hideSidebar} />
         
        </ul>

        )}
        {this.state.create_bulk_user &&(

        <ul className="sidebar__block" style={{borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8}}>
        <SidebarLink title="Create Bulk User" route="/receiving/create_bulk_user" onClick={this.hideSidebar} /> 
        </ul>

        )}
        {this.state.admin_reset_password &&(

          <ul className="sidebar__block" style={{borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8}}>
          <SidebarLink title="Admin Reset Password" route="/account/admin/reset-password" onClick={this.hideSidebar} /> 
          </ul>

        )}
        

        {/*<ul className="sidebar__block" style={{borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8}}>
          <SidebarCategory title="Product IT" icon={faBoxes} changeSidebarVisibility={changeSidebarVisibility}>
            <SidebarLink title="Product Search" route="/pages/one" onClick={this.hideSidebar} />
             <SidebarLink title="Product Ledger" route="/productIT/productLedger" onClick={this.hideSidebar} />
          </SidebarCategory>
        </ul>*/}

        {/*<ul className="sidebar__block" style={{borderBottomWidth: 0, paddingTop: 8, paddingBottom: 8}}>
          <SidebarLink title="PRODUCT LEDGER" icon={faBoxes} changeSidebarVisibility={changeSidebarVisibility} route="/productIT/productLedger" onClick={this.hideSidebar} />
         
        </ul>
        
    <ul className="sidebar__block" style={{borderBottomWidth: 0 , paddingTop: 8, paddingBottom: 8}}>
          <SidebarCategory title="Cycle Count" icon={faFileAlt} changeSidebarVisibility={changeSidebarVisibility}>
            <SidebarLink title="Cycle Count Dashboard" route="/cycleCount/assignUser" onClick={this.hideSidebar} />
            <SidebarLink title="Cycle Count Confirmation" route="/cycleCount/cycleCountConfirmation" onClick={this.hideSidebar} />
          </SidebarCategory>
        </ul>*/}
        {/*<ul className="sidebar__block" style={{borderBottomWidth: 0 , paddingTop: 8, paddingBottom: 8}}>
          <SidebarCategory title="Maintenance" icon={faWrench} changeSidebarVisibility={changeSidebarVisibility}>
        <SidebarLink title="Bin Consolidation" route="/maintenance/BinconsolidationDashboard" onClick={this.hideSidebar} />
            <SidebarLink title="Cycle Count" route="/maintenance/cycleCount/assignUser" onClick={this.hideSidebar} />
      <SidebarLink title="Customer vs WMS Inventory" route="/maintenance/Customervswmsinvetory" onClick={this.hideSidebar} />
      <SidebarLink title="Stock Movement" route="/maintenance/stockMovement" onClick={this.hideSidebar} />
          </SidebarCategory>
          
        </ul>*/}


      </div>
    );
  }
}

export default SidebarContent;
